module.exports = __webpack_public_path__ + "img/baden_wuertemberg.60751f42.png";